<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/wnioski-wyslane' aria-label='Wnioski wysłane'>
        Wnioski wysłane
      </a>
    </li>
    <li>
      {{ serviceType()?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <br>
    <app-alert-container [dismissible]='false'></app-alert-container>
    @if (!loading()) {
      <div class='download-actions' *ngIf='application()'>
        <button class='btn btn-secondary' (click)='uppPreview.show()'>
          <i aria-hidden='true' class='fa fa-file'></i>
          Pokaż UPP
        </button>
      </div>
      <app-upp-preview [application]="application()" #uppPreview></app-upp-preview>
      <h2>
        {{ serviceType()?.name }}
      </h2>
      <app-application-preview [application]="application()">
      </app-application-preview>
    }
    <ng-container *ngIf='!loading() && !uiSettings()?.mobileEmbed'>
      <br>
      <div class='application-actions'>
        <button
          type='button'
          class='btn btn-secondary' routerLink='../../'>
        <span>
          Wstecz
        </span>
        </button>
      </div>
    </ng-container>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
